/**
 * Daydra logo — SVG node graph.
 * Single source of truth for the app logo. Change here to update everywhere.
 */
export function DaydraLogo({ size = 28, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-46 -46 92 92"
      width={size}
      height={size}
      className={className}
    >
      <g>
        {/* Central node */}
        <circle cx="0" cy="0" r="8" fill="currentColor" />
        {/* Primary orbital nodes */}
        <circle cx="40" cy="0" r="6" fill="currentColor" />
        <circle cx="-40" cy="0" r="6" fill="currentColor" />
        <circle cx="0" cy="40" r="6" fill="currentColor" />
        <circle cx="0" cy="-40" r="6" fill="currentColor" />
        {/* Secondary orbital nodes */}
        <circle cx="28" cy="28" r="4" fill="currentColor" />
        <circle cx="-28" cy="-28" r="4" fill="currentColor" />
        <circle cx="28" cy="-28" r="4" fill="currentColor" />
        <circle cx="-28" cy="28" r="4" fill="currentColor" />
        {/* Connection lines */}
        <line x1="0" y1="0" x2="40" y2="0" stroke="currentColor" strokeWidth="2" />
        <line x1="0" y1="0" x2="-40" y2="0" stroke="currentColor" strokeWidth="2" />
        <line x1="0" y1="0" x2="0" y2="40" stroke="currentColor" strokeWidth="2" />
        <line x1="0" y1="0" x2="0" y2="-40" stroke="currentColor" strokeWidth="2" />
        {/* Diagonal connections */}
        <line x1="0" y1="0" x2="28" y2="28" stroke="currentColor" strokeWidth="1.5" />
        <line x1="0" y1="0" x2="-28" y2="-28" stroke="currentColor" strokeWidth="1.5" />
        <line x1="0" y1="0" x2="28" y2="-28" stroke="currentColor" strokeWidth="1.5" />
        <line x1="0" y1="0" x2="-28" y2="28" stroke="currentColor" strokeWidth="1.5" />
      </g>
    </svg>
  );
}
